// eslint-disable-next-line import/prefer-default-export
export const DELETE_LOCAL_SALON_TAG = 'DELETE_LOCAL_SALON_TAG';
